import { Button, Group, Modal } from "@veneer/core";

type props = {
  setOpenCloseModal: () => void,
  openModal: boolean,
  titleMessage: string,
  message: string,
  onClickYes: () => void,
  onClickNo: () => void,
  titleButtonYes: string,
  titleButtonNo: string,
  id: string
}

export const ModalQuestion = ({
  setOpenCloseModal,
  openModal,
  titleMessage,
  message,
  onClickYes,
  onClickNo,
  titleButtonYes,
  titleButtonNo,
  id
}: props) => {
  return (
    <div style={{ position: "relative" }}>
      <Modal
        align="center"
        id={id}
        show={openModal}
        onClose={setOpenCloseModal}
        title={titleMessage}
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Group>
              <Button onClick={onClickYes}>{titleButtonYes}</Button>
              <Button appearance="secondary" onClick={onClickNo}>
                {titleButtonNo}
              </Button>
            </Group>
          </div>
        }
      >
        <p>{message}</p>
      </Modal>
    </div>
  );
};
